import { nodeApi } from "@/redux/api/nodeApi";
import { TResponseRedux } from "@/types/types";
export type TQueryParam = {
  name: string;
  value: boolean | React.Key;
};
const notificationApi = nodeApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: (args) => {
        const params = new URLSearchParams();
        if (args) {
          args.forEach((element: TQueryParam) => {
            params.append(element.name, element.value as string);
          });
        }
        return {
          url: "/notification",
          method: "GET",
          params: params,
        };
      },
      providesTags: ["Notifications"],
    }),

    markAsRead: builder.mutation({
      query: ({ id }) => ({
        url: `/notification/mark-as-read/${id}`,
        method: "POST",
      }),
      invalidatesTags: ["Notifications"],
    }),
    markAllAsRead: builder.mutation({
      query: (payload) => ({
        url: `/notification/mark-all-as-read/${payload?.email}`,
        method: "POST",
      }),
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
} = notificationApi;
